// extracted by css-extract-rspack-plugin
export default {"link":"_7a0c128e","hideDivider":"_773f1c2f","isSbTile":"_3631d031"};